export default {
  'consumption-date-aria-label': 'Date limite de consommation',
  'unavailable': 'Épuisé',
  'back-on': 'Retour le',
  'no-substitute-product': 'Bientôt disponible',
  'new-tag': 'Nouveau',
};
